var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".notify-employer_svg__st5{fill:#fff}.notify-employer_svg__st6{fill:#ea4403}.notify-employer_svg__st7{fillRule:evenodd;clip-rule:evenodd;fill:#0e1375}");

var _ref3 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "notify-employer_svg__SVGID_1_",
  cx: 40,
  cy: 40,
  r: 40
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "notify-employer_svg__SVGID_00000099658801379492981050000004513783029174021807_"
}, /*#__PURE__*/React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#notify-employer_svg__SVGID_1_"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#notify-employer_svg__SVGID_00000099658801379492981050000004513783029174021807_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "notify-employer_svg__SVGID_00000054238395243817611210000014499767699019149747_",
  d: "M0 0h80v80H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "notify-employer_svg__SVGID_00000096763793707302027640000015678274913903690933_"
}, /*#__PURE__*/React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#notify-employer_svg__SVGID_00000054238395243817611210000014499767699019149747_"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#notify-employer_svg__SVGID_00000096763793707302027640000015678274913903690933_)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#eaeaea",
  d: "M80.001 40c0 22.09-17.91 40-40 40-22.091 0-40-17.91-40-40 0-22.093 17.909-40 40-40 22.09 0 40 17.907 40 40"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#260046",
  fillRule: "evenodd",
  d: "M35.636 48.237l-.039-3.242-11.272.136.04 3.241 1.53-.018.23 17.201a2.203 2.203 0 002.231 2.178l3.617-.044a2.203 2.203 0 002.177-2.231l-.23-17.2 1.716-.021z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#260046",
  d: "M66.907 34.685a6.517 6.517 0 00-6.186-6.425l.157 12.997a6.517 6.517 0 006.029-6.572z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.609 25.057l-18.608.225h-.006l13.576-.164.239 19.863 5.037-.061c6.64 1.072 13.309 6.067 16.602 8.853L57.991 15.8c-3.224 2.866-9.769 8.025-16.382 9.257zM13.977 34.435l-.005-.001a.89.89 0 10.021 1.779l.005-.001a9.132 9.132 0 009.059 8.926l-.239-19.845a9.13 9.13 0 00-8.841 9.142z",
  className: "notify-employer_svg__st5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.995 25.282l-.177.002v.009l.239 19.845.001.08 13.753-.166-.001-.071-.239-19.863zM60.543 13.541a1.29 1.29 0 00-2.58.031l.027 2.228.458 37.973.02 1.656a1.29 1.29 0 102.579-.031l-.171-14.14-.155-12.998-.178-14.719z",
  className: "notify-employer_svg__st6"
}), /*#__PURE__*/React.createElement("path", {
  id: "notify-employer_svg__Fill-40",
  d: "M16.575 37.427l4.571-.056a.36.36 0 00.357-.366l-.001-.103a.36.36 0 00-.366-.357l-4.57.055a.362.362 0 00-.358.365l.001.104c.003.2.167.36.366.358",
  className: "notify-employer_svg__st7"
}), /*#__PURE__*/React.createElement("path", {
  id: "notify-employer_svg__Fill-43",
  d: "M16.555 35.741l4.57-.055c.2-.003.36-.166.358-.367l-.002-.103a.36.36 0 00-.365-.357l-4.571.055a.362.362 0 00-.358.365l.001.104a.363.363 0 00.367.358",
  className: "notify-employer_svg__st7"
}), /*#__PURE__*/React.createElement("path", {
  id: "notify-employer_svg__Fill-46",
  d: "M16.534 34.057l4.571-.055c.2-.003.36-.167.357-.367l-.001-.103a.36.36 0 00-.366-.357l-4.57.055a.361.361 0 00-.358.365v.104c.004.2.168.36.367.358",
  className: "notify-employer_svg__st7"
})))));

var SvgNotifyEmployer = function SvgNotifyEmployer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notify-employer_svg__Layer_2",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotifyEmployer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notify-employer.b1047d5a.svg";
export { ForwardRef as ReactComponent };